import { Box, Flex, Icon, Collapse, useDisclosure } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { ChevronDown, ChevronRight } from '@kula-ai/icons-core';

interface CollapsibleSectionProps {
  title?: string;
  children: React.ReactNode;
  defaultIsOpen?: boolean;
  headerAction?: React.ReactNode;
  sectionStyles?: React.CSSProperties;
}

export const CollapsibleSection = ({
  title = 'Details',
  children,
  defaultIsOpen = true,
  headerAction,
  sectionStyles = {},
}: CollapsibleSectionProps) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen });

  return (
    <Box
      borderRadius="xs"
      border="1px solid"
      borderColor="border-color"
      overflow="hidden"
    >
      <Flex
        flex="1"
        p={sectionStyles.padding || '10px 16px'}
        bg="secondary-25"
        gap="6px"
        alignItems="center"
        borderBottom={isOpen ? '1px solid' : 'none'}
        borderColor="border-color"
        justifyContent="space-between"
      >
        <Flex
          gap="6px"
          alignItems="center"
          cursor="pointer"
          onClick={onToggle}
          flex="1"
        >
          <Icon
            width="16px"
            height="16px"
            cursor="pointer"
            as={isOpen ? ChevronDown : ChevronRight}
          />
          <KText variant="heading_4" color="primary-900" fontWeight="semiBold">
            {title}
          </KText>
        </Flex>
        {headerAction && (
          <Box onClick={(e) => e.stopPropagation()}>{headerAction}</Box>
        )}
      </Flex>
      <Collapse in={isOpen} unmountOnExit={false}>
        {children}
      </Collapse>
    </Box>
  );
};
